// extracted by mini-css-extract-plugin
export default {"statusCard":"ReportStatusDisplay_statusCard__UnVGd","spinnerContainer":"ReportStatusDisplay_spinnerContainer__di+SU","title":"ReportStatusDisplay_title__Vjgvx"};